<template>
  <div>

    <ul>
      <div class="accordion-item accordionForm">
        <a href="#" id="rtp-general-settings" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner">
            <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.gnrl') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.rcv_rqst_to_pay_eml') }}</label>
            <label class="label-switch">
              <input type="checkbox" class="checkboxSendPaymentsRequestEmail" @change="switchSendPaymentsRequestEmail" :disabled="canSwitchSendEmail()" :checked="settings.sendPaymentRequestEmail === '1'" v-bind:value="settings.sendPaymentRequestEmail">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.ngttn_as_dflt') }}</label>
            <label class="label-switch">
              <input type="checkbox" class="checkboxDefaultNegotiationAllowed" @change="changeSwitchDefaultNegotiationAllowed" :disabled="canSwitchDefaultNegotiation()" :checked="settings.defaultNegotiationAllowed === '1'" v-bind:value="settings.defaultNegotiationAllowed">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.activate_OCR') }}</label>
            <label class="label-switch">
              <input type="checkbox" class="checkboxOcrActivation" @change="changeSwitchOcrActivation" :disabled="canSwitchOcrActivation()" :checked="settings.ocrActivation === '1'" v-bind:value="settings.ocrActivation" >
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group d-flex justify-content-between">
            <label class="col-form-label">{{ $t('settings.gnrt_bnk_trnsfr_ordr')}}</label>
              <label class="label-switch">
                <input type="checkbox" class="checkboxIsToGenerateXML" @change="changeSwitchIsToGenerateXML" :disabled="canSwitchGeneratePain()" :checked="settings.isToGenerateXML === '1'" v-bind:value="settings.isToGenerateXML">
                <div class="checkbox"></div>
              </label>
          </div>
          <div class="form-group">
            <label class="col-form-label">{{ $t('settings.vldtn_amnt') }}</label>
            <div class="" style="text-align: right;">{{settings.validationThreshold}}</div>
            <input class="range-slider-streammind" :class="sliderColorClass" type="range" min="0" max="150000" value="0" step="500" :disabled="canSwitchValidationThreshold()" v-model="settings.validationThreshold">
          </div>
        </div>

      </div>
    </ul>

    <hr>

    <ul>
      <div class="accordion-item accordionForm">
        <a href="#" id="rtp-payment-method-settings" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner">
            <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.pymnt_mthd') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group row">
            <div class="form-group col-sm-auto">
              <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" id="defaultInline1" type="radio" name="methodRadio" value="application" :disabled="canSwitchPaymentMethod()" v-model="settings.paymentMethod">
                <label class="custom-control-label" for="defaultInline1" :disabled="canSwitchPaymentMethod()">{{ $t('settings.crdt_trnsfr') }}</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input class="custom-control-input" id="defaultInline2" type="radio" name="methodRadio" value="bankCard" :disabled="canSwitchPaymentMethod()" v-model="settings.paymentMethod">
                <label class="custom-control-label" for="defaultInline2" :disabled="canSwitchPaymentMethod()">{{ $t('settings.bnk_crd') }}</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ul>

    <hr>

    <ul>
      <div class="accordion-item accordionForm">
        <a href="#" id="rtp-negotiation-settings" class="item-content item-link" @click="rotateChevron($event)">
          <div class="item-inner">
            <div class="form-group row justify-content-start styleGeneral">
                <div class="item-title createInvoiceBand col-sm-auto">
                  {{ $t('common.formsSubTitle.ngttn') }}
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
            </div>
          </div>
        </a>

        <div class="accordion-item-content">
          <div class="form-group d-flex justify-content-between" style="margin-inline: initial;">
            <label class="col-form-label">{{ $t('settings.actvt_ngttn') }}</label>
            <label class="label-switch" >
              <input type="checkbox" class="checkboxNegotiationActivated" v-b-toggle="'collapse-2'" :checked="settings.negotiationActivated" @change="switchNegotiationActivated" :disabled="canSwitchNegociation()" v-bind:value="settings.negotiationActivated">
              <div class="checkbox"></div>
            </label>
          </div>
          <div class="form-group">
            <b-collapse :visible="settings.negotiationActivated === '1'" id="collapse-2" class="mt-2">
              <div class="form-group row">
                <div class="col-md-4">
                  <label class="col-form-label">{{ $t('settings.ngttn_thrshld') }}</label>
                </div>
                <div class="col-sm-auto">
                  <input class="form-control" type="number" onkeydown="return event.keyCode !== 69" placeholder="Negotiation threshold" value="">
                </div>
              </div>
              <div class="form-group row">
                <div class="col-md-4">
                  <label class="col-form-label">{{ $t('common.installment_number') }}</label>
                </div>
                <div class="col-md-auto">
                  <select class="installmentSelect button-setting" v-model="settings.defaultInstallmentNumber">
                    <option v-for="n in 6"  :min="2" :value="n">{{n}}</option>
                  </select>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>

      </div>
    </ul>

  </div>
</template>

<script>
export default {
  props: ['settings'],
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id)
    }
  },
  computed: {
    sliderColorClass () {
      // let fromIdServiceToSliderClass = {
        // '1': 'RTP-slider',
        // '2': 'DD-slider',
        // '6': 'DP-slider'
      // }
      // return fromIdServiceToSliderClass[this.$engine.user.currentService.id]
      return 'RTP-slider'
    }
  },
  created () {
  },
  mounted () {
    // expand all menus
    let that = this
    this.Dom7('.accordion-item').addClass('accordion-item-expanded').forEach(item => {
      that.Dom7(item).addClass('accordion-item-expanded')
    })
    this.Dom7('.createInvoiceBand').forEach(item => {
      that.Dom7(item).find('i').transform('rotate(90deg)')
    })
    // console.log(this.canSwitchGeneratePain())
    // console.log(this.$engine.rights.get('rtp_settings_unit_nego_allowed'))
  },
  methods: {
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    canSwitchNegociation () {
      return this.$engine.rights.rightIs('rtp_settings_unit_nego_allowed', false)
    },
    switchNegotiationActivated (event) {
      this.negotiationActivated = event.target.checked
      if (this.negotiationActivated) {
        this.Dom7(event.target).parent().parent().parent().parent().parent().parent().next().addClass('accordion-item-expanded')
      } else {
        this.Dom7(event.target).parent().parent().parent().parent().parent().parent().next().removeClass('accordion-item-expanded')
      }
    },
    canSwitchValidationThreshold () {
      return this.$engine.rights.rightIs('rtp_settings_unit_validation_threshold', false)
    },
    canSwitchSendEmail () {
      return this.$engine.rights.rightIs('rtp_settings_unit_send_email', false)
    },
    switchSendPaymentsRequestEmail (obj) {
      this.settings.sendPaymentRequestEmail = obj.target.checked
    },
    canSwitchDefaultNegotiation () {
      return this.$engine.rights.rightIs('rtp_settings_unit_nego_allowed', false)
    },
    changeSwitchDefaultNegotiationAllowed (obj) {
      this.settings.defaultNegotiationAllowed = obj.target.checked
    },
    canSwitchOcrActivation () {
      return this.$engine.rights.rightIs('rtp_settings_unit_ocr_activation', false)
    },
    changeSwitchOcrActivation (obj) {
      this.settings.ocrActivation = obj.target.checked
    },
    canSwitchGeneratePain () {
      return this.$engine.rights.rightIs('rtp_settings_unit_generate_pain', false)
    },
    changeSwitchIsToGenerateXML (obj) {
      this.settings.isToGenerateXML = obj.target.checked
    },
    canSwitchPaymentMethod () {
      return this.$engine.rights.rightIs('rtp_settings_unit_payment_method', false)
    }
  }
}
</script>
<style>
.styleGeneral:hover {
  text-decoration: underline;
  text-decoration-color: #51a45c;
}
</style>



// WEBPACK FOOTER //
// RequestToPaySettings.vue?36ae4b0c